import { apiClient } from './api';
import type { DefenderType, UserDefender } from '@types';

export const defenderService = {
  /**
   * Get all defender types (base stats)
   */
  async getDefenderTypes(): Promise<DefenderType[]> {
    const { data } = await apiClient.get<DefenderType[]>('/api/v1/defender');
    return data;
  },

  /**
   * Get user's defenders (progress/levels)
   */
  async getUserDefenders(): Promise<UserDefender[]> {
    const { data } = await apiClient.get<UserDefender[]>(
      '/api/v1/user/defenders'
    );
    return data;
  },

  /**
   * Upgrade a defender
   */
  async upgradeDefender(defenderId: number): Promise<UserDefender> {
    const { data } = await apiClient.post<UserDefender>(
      '/api/v1/user/defenders/upgrade',
      { defenderId }
    );
    return data;
  },
};
